// extracted by mini-css-extract-plugin
export default {"table":"performance-metrics-table_table__ebqEb"};